import React from 'react'

function Footer() {
  return (
    <footer className="w-full h-fit flex-row mt-10 text-center text-rosemadder font-bold font-nunito ">
       &copy; {new Date().getFullYear()} &nbsp;
        <a className='' href='https://recipebox.vercel.app/'>
           RecipeNook
        </a>
    </footer>
  )
}

export default Footer